import SalesForceCRUDActions from '../actions/SalesForceCRUDActions';
import {
  SalesForceAccount,
  SalesForceAttribute,
  SalesForceModel,
} from '../model/SalesForceModel';
import TagModel from '../model/TagModel';
import { setBusy, setUnBusy } from './common/commonReducers';

type ActionType = {
  type: string;
  accounts: SalesForceAccount[];
  attributes: SalesForceAttribute[];
  tags: TagModel[];
};

const initialState: SalesForceModel = {
  busy: false,
  accounts: [],
  attributes: [],
  tags: [],
  tagsEnabled: null,
};

export const salesForce = (state = initialState, action: ActionType) => {
  switch (action.type) {
    case SalesForceCRUDActions.busyAction:
      return setBusy(state);
    case SalesForceCRUDActions.retrieveOauthUrlAction: {
      return {
        ...state,
        busy: false,
      };
    }
    case SalesForceCRUDActions.retrieveAccounts: {
      return {
        ...state,
        accounts: action.accounts,
        busy: false,
      };
    }

    case SalesForceCRUDActions.retrieveAttributes: {
      return {
        ...state,
        attributes: action.attributes,
        busy: false,
      };
    }
    case SalesForceCRUDActions.retrievedAvailableTags: {
      return {
        ...state,
        tags: action.tags.map(e => ({ name: e })),
        busy: false,
        tagsEnabled: true,
      };
    }
    case SalesForceCRUDActions.tagsDisabledAction: {
      return {
        ...state,
        busy: false,
        tagsEnabled: false,
      };
    }
    case SalesForceCRUDActions.revokeAction: {
      return {
        ...state,
        busy: false,
      };
    }
    case SalesForceCRUDActions.resetStore: {
      return initialState;
    }
    case SalesForceCRUDActions.unbusyAction:
      return setUnBusy(state);
    default:
      return state;
  }
};
